import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest, postRequest, putRequest } from 'utilities/service.utils';
import AppService from './app.service.context';
import {
  SystemUploadRequestPlayload,
  AoiListRequestParams,
  UploadNewAoiRequestParams
} from 'types';

export const getNewUploadLocation = async (
  requestBody: SystemUploadRequestPlayload
) => {
  const payload = {
    ...requestBody
  };
  const urlBuilder = createUrlBuilder('/system/uploads').toString();

  return await postRequest(AppService, urlBuilder, payload);
};

export const putNewAreaOfInterestUpload = async (
  signedUrl: string,
  file: File
) => {
  const body = await file.arrayBuffer();
  const responseBody = await fetch(signedUrl, {
    method: 'PUT',
    body
  });

  return responseBody;
};

export const getUploadAreaOfInterestJob = async (
  fileId: string,
  params: UploadNewAoiRequestParams
) => {
  const urlBuilder = createUrlBuilder(`/system/uploads/${fileId}`).toString();

  return await getRequest(AppService, urlBuilder, params);
};

export const putNewAreaOfInterest = async (
  payload: GeoJSON.GeometryObject,
  organisationId: string,
  preview = false,
  returnEnquiryVolume = false
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/area-of-interest?preview=${
      preview ? 'true' : 'false'
    }&returnEnquiryVolume=${returnEnquiryVolume ? 'true' : 'false'}`
  ).toString();

  const responseBody = await putRequest(AppService, urlBuilder, payload)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error;
    });
  return responseBody;
};

export const getAOI = async (
  organisationId: string,
  aoiId: number,
  returnEnquiryVolume: boolean = true
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/area-of-interest/${aoiId}?returnGeometry=false${
      !returnEnquiryVolume ? '&returnEnquiryVolume=false' : ''
    }`
  ).toString();

  return await getRequest(AppService, urlBuilder);
};

export const getAOIList = async (
  params: AoiListRequestParams,
  organisationId: string
) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/${organisationId}/area-of-interest`
  ).toString();

  return await getRequest(AppService, urlBuilder, params);
};

export const getLGABoundariesList = async (state: string) => {
  const urlBuilder = createUrlBuilder(
    `/system/boundaries/lga?returnGeometry=false&order=name&limit=1000&filter=state:${state}`
  ).toString();

  return await getRequest(AppService, urlBuilder);
};

export const getLGABoundary = async (id: string) => {
  const urlBuilder = createUrlBuilder(
    `/system/boundaries/lga/${id}?returnGeometry=true`
  ).toString();

  return await getRequest(AppService, urlBuilder);
};
